import axios from "axios";
import { PACOCA_API_URL } from "../global-components/src/utils/vars";

export const fetchUsers = async (searchTerm: string, token: string) => {
    if (!searchTerm) return null;

    try {
      const res = await axios.get(`${PACOCA_API_URL}/search`, {
        params: {
          typeSeach: "user",
          search: searchTerm,
        },
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data;
    } catch (err) {
        throw err;
    }
  };